import { Axios } from '../axios';

const getDashboard = async (payload) => {
  const { data } = await Axios.get('/spend/dashboard/', {
    timeout: 30000,
  })
  return data?.data
}

export const spendDashboard = {
    getDashboard,
};
